import type { ApiMarket } from '#/api/types';

// Actions

export const loadMarkets = (
  loggedIn: boolean,
  markets: ApiMarket[],
  defaultMarket: string
) => ({
  type: 'LOAD_MARKETS' as const,
  loggedIn,
  markets,
  defaultMarket,
  /** Poll scheduling reference — any reload (websocket, GEO) pushes the next poll out */
  loadedAtMs: Date.now(),
});

export const debugUpdateMarketsStatus = (status: ApiMarket['status']) => ({
  type: 'DEBUG_UPDATE_LISTED_MARKETS_STATUS' as const,
  status,
});

/** Use with upcoming (hidden) unlisted markets */
export const loadHiddenMarket = (market: ApiMarket) => ({
  type: 'LOAD_HIDDEN_MARKET' as const,
  market,
});
